var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:[_vm.isBtnDFlex ? 'v-btn--block' : '', { 'disable-events': _vm.disabled }],attrs:{"round":"","large":"","color":_vm.colorCode,"dark":_vm.isDark,"outline":_vm.hasOutline,"flat":_vm.disabled,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }